import useOpen from '@/hooks/useOpen';
import AppContent from '@/components/AppContent';
import './helpers/fetchInterceptor';

export const App = () => {
  const isOpen = useOpen();

  if (!isOpen) {
    return null;
  }

  return <AppContent />;
};

export default App;
